module.exports = __webpack_public_path__ + "static/media/tavi.14a560ca.png";